export default{
    lab: "Laboratory Name",
    date: "Date",
    spermConcentration: "Sperm Concentration",
    totalSpermNumber: "Total SpermNumber",
    progressiveMotility: "Progressive Motility",
    normalForms: "Normal Forms",
}